import React, { Suspense, useEffect, useState } from 'react';
import { AuthRoot } from '@bbkAdminComponents/app-layout/auth-root';
import { LogInPaths } from '@bbkAdminComponents/log-in-flow/log-in-paths';
import { PreparingOverlay } from '@bbkAdminComponents/preparing-overlay/preparing-overlay';
import { preauthCompanySlice } from '@bbkAdminRedux/rtkq/preauth-company.slice';
import { usePollAndNotifyVersion } from '@bbkAdminRedux/rtkq/version.slice';
import { LogoutPage } from '@bbkAdminRouter/logout.page';
import { SignupPaths } from '@bbkAdminRouter/signup-paths';
import { correctBaseURI } from '@bbkAdminUtils/getCurrentBaseUri';
import { GlobalLogger } from '@bbkAdminUtils/GlobalLogger';
import { Route, Routes } from '@bbkShared/react-router';
import { useBbkFavicon } from '@bbkShared/utils/favicon';
import { usePageTitle } from '@bbkShared/utils/page-title';

import '@bbkAdminStylesheets/tailwind.scss';

const SignupRouter = React.lazy(() => import('@bbkAdminRouter/signup.router'));
const CBIDPExchange = React.lazy(
  () => import('@bbkAdminComponents/log-in-flow/cbidp-exchange')
);

// ATTN: Keep routes simple, no logic
// Only simple route declarations with page elements.
const AdminAppRouter = () => (
  <Suspense fallback={<PreparingOverlay message="" />}>
    <Routes>
      <Route path={`${LogInPaths.logout}/*`} element={<LogoutPage />} />
      <Route
        path={`${LogInPaths.cbidpExchange}/*`}
        element={<CBIDPExchange />}
      />
      <Route path={`${SignupPaths.trialSignup}/*`} element={<SignupRouter />} />
      <Route path="*" element={<AuthRoot />} />
    </Routes>
  </Suspense>
);

export const AdminApp: React.FC = () => {
  usePollAndNotifyVersion();
  useBbkFavicon();
  usePageTitle();

  const [isLoadingFinished, setIsLoadingFinished] = useState<boolean>();
  const [getClientConfig$] =
    preauthCompanySlice.endpoints.getClientConfig.useLazyQuery();

  useEffect(() => {
    getClientConfig$()
      .unwrap()
      .then((config) => correctBaseURI(config))
      .catch(GlobalLogger.error)
      .finally(() => setIsLoadingFinished(true));
  }, [getClientConfig$]);

  if (!isLoadingFinished) return null;

  return <AdminAppRouter />;
};
